module.exports = __webpack_public_path__ + "static/media/14UNEP23.e586a496.jpg";